module.exports = __webpack_public_path__ + "static/media/kresus.335c6180.jpeg";